import { NgModule } from '@angular/core';
import { AddNewCommentComponent } from './add-new-comment/add-new-comment.component';
import { AddNewReactionComponent } from './add-new-reaction/add-new-reaction.component';
import { AddReactionButtonComponent } from './add-reaction-button/add-reaction-button.component';
import { BasePostCardComponent } from './base-post-card/base-post-card.component';
import { PublicationCardComponent } from './publication-card/publication-card.component';

import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { TranslateModule } from '@ngx-translate/core';
import { QuillModule } from 'ngx-quill';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { TooltipModule } from 'primeng/tooltip';
import { SharedModule } from '../../shared.module';
import { MentionListComponent } from '../mention/mention-list.component';
import { MentionDirective } from '../mention/mention.directive';
import { CommentCardComponent } from './comment-card/comment-card.component';
import { CreatePublicationButtonModalComponent } from './create-publication-modal-button/create-publication-modal-button.component';
import { GearEditPostComponent } from './gear-edit-post/gear-edit-post.component';
import { ListItemUserComponent } from './list-item-user/list-item-user.component';
import { ModalPublicationPictureComponent } from './modal-publication-picture/modal-publication-picture.component';
import { ModalPublicationReactionDetailsComponent } from './modal-publication-reactions-details/modal-publication-reactions-details';
import { SelectRoomsAccordionComponent } from './select-rooms-accordion/select-rooms-accordion.component';
import { UpdateCommentButtonModalComponent } from './update-comment-modal/update-comment-modal-button.component';

const moduleItems = [
    PublicationCardComponent,
    BasePostCardComponent,
    AddReactionButtonComponent,
    AddNewCommentComponent,
    AddNewReactionComponent,
    MentionDirective,
    MentionListComponent,
    ListItemUserComponent,
    CommentCardComponent,
    UpdateCommentButtonModalComponent,
    GearEditPostComponent,
    ModalPublicationPictureComponent,
    ModalPublicationReactionDetailsComponent,
    SelectRoomsAccordionComponent,
    CreatePublicationButtonModalComponent,
];

@NgModule({
    declarations: [...moduleItems],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        QuillModule,
        TranslateModule,
        AvatarModule,
        ButtonModule,
        CardModule,
        TooltipModule,
        PickerModule,
        SharedModule,

    ],
    exports: [...moduleItems],
})
export class PublicationModule { }
